import { createSlice } from "@reduxjs/toolkit";
import {
  ApprovedStatus,
  ValidStatusInternalDocument,
} from "core/http/service/internalDocument/resTypes";

interface InitialState {
  formData: {
    approvedLevelId?: string;
    categoryId?: number | string;
    departmentId?: string;
    effectiveDateFrom?: string;
    effectiveDateTo?: string;
    isHighlight?: boolean;
    approvedStatus?: ApprovedStatus;
    issueDateFrom?: string;
    issueDateTo?: string;
    keyword?: string;
    validStatus?: ValidStatusInternalDocument | string;
  };
  isSearching: boolean;
}

const initialState: InitialState = {
  formData: {
    keyword: "",
    validStatus: "",
    categoryId: "",
    departmentId: "",
    approvedLevelId: "",
  },
  isSearching: false,
};

const fromSearchInternalDocumentSlice = createSlice({
  name: "fromSearchInternalDocument",
  initialState,
  reducers: {
    updateSearchState: (state, action) => {
      state.isSearching = action.payload;
    },
    updateFormSearchInternalDocument: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },

    resetFormSearchInternalDocument: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormSearchInternalDocument,
  resetFormSearchInternalDocument,
  updateSearchState,
} = fromSearchInternalDocumentSlice.actions;

export default fromSearchInternalDocumentSlice.reducer;
